import {
  ReferencesLink,
  PlantsOverviewTableContainer,
  useDocsLink,
  useHierarchyDownload,
  usePlantViewParam
} from '@features/pom'
import {PlantViewToggle} from '@hconnect/common/components'
import {
  PageTitle,
  CardBox,
  PageContainer,
  buttonOnBlueSx,
  mergeSxs,
  customThemeConstants
} from '@hconnect/uikit/src/lib2'
import {FileDownload} from '@mui/icons-material'
import {LoadingButton} from '@mui/lab'
import {Box, Stack} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

export const PlantsGlobalOverviewPage: React.FC = () => {
  const {t} = useTranslation()
  const [plantView, setPlantView] = usePlantViewParam()
  const {isPending: downloadIsLoading, mutate: downloadOverview} = useHierarchyDownload()
  const {data} = useDocsLink()

  return (
    <PageContainer>
      <Box display={'flex'} flexDirection={{xs: 'column', sm: 'row'}} alignItems="center">
        <Stack flex={1}>
          <PageTitle mb={0}>{t('plantOverviewPage.title')}</PageTitle>
          {data && (
            <Box display="inline-flex">
              <ReferencesLink guidanceLink={data} color="primary.contrastText" />
            </Box>
          )}
        </Stack>
        <Box display="flex" mb={customThemeConstants().defaultGridSpacing}>
          <PlantViewToggle t={t} value={plantView} onChange={setPlantView} />
          <LoadingButton
            variant={'text'}
            color={'primary'}
            startIcon={<FileDownload />}
            sx={mergeSxs(buttonOnBlueSx, {ml: 1})}
            loading={downloadIsLoading}
            onClick={() => downloadOverview()}
          >
            {t('button.download')}
          </LoadingButton>
        </Box>
      </Box>
      <CardBox>
        <PlantsOverviewTableContainer plantView={plantView} />
      </CardBox>
    </PageContainer>
  )
}
